import { useCallback } from 'react';
import apiFetch from "../utils/apiFetch";
import { protectedResources } from "../authConfig";
import { useMsal } from "@azure/msal-react";
import { useAppNavigation } from "./useAppNavigation";

export const useAuthenticatedApiFetch = () => {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();

  const { goToError, goToLogin, goToUnauthorized } = useAppNavigation(); 

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    }).catch(e => {
      console.error(e);
    });
  };

  const doFetch = (url, options, accessToken, responseType, language) => {
    return apiFetch(
      url,
      {
        ...options,
        headers: {
          ...options.headers,
          'Authorization': `Bearer ${accessToken}`,
          'Accept-Language': language,
        },
      },
      responseType,
      language,
      goToError,
      goToUnauthorized
    );
  };

  return useCallback(
    async (url, options = {}, responseType = "json", language = "en") => {
      if (!account) {
        console.error("No accounts found. User might not be signed in.");
        handleLogout();
        throw new Error("No accounts found. User might not be signed in.");
      }

      try {
        const accessTokenResponse = await instance.acquireTokenSilent({
          account,
          scopes: protectedResources.api.scopes.read,
        });

        const accessToken = accessTokenResponse.accessToken;

        const result = await doFetch(url, options, accessToken, responseType, language);

        if (result === null) {
          return null;
        }

        return result;

      } catch (error) {
        console.error("Error acquiring token silently:", error);
        handleLogout();
        //goToLogin();
        throw new Error("Error acquiring access token");
      }
    },
    [instance, account, goToError, goToLogin, goToUnauthorized] 
  );
};
